// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b605b62b","455":"861558c7","823":"ef797a49","977":"53f7cdfd"}[chunkId] + ".chunk.js";
};